import { useEffect, useState } from "react";

const useOrientation = () => {
    const [isLandscape, setIsLandscape] = useState(false);

    useEffect(() => {
        // Check if device has touch capability
        const isTouchDevice = ('ontouchstart' in window) || 
                            (navigator.maxTouchPoints > 0) || 
                            (navigator.msMaxTouchPoints > 0);

        if (!isTouchDevice) {
            setIsLandscape(false);
            return; // Don't set up listeners if not a touch device
        }

        const checkOrientation = () => {
            const width = window.innerWidth;
            const height = window.innerHeight;
            const isLandscapeMode = width > height;
            setIsLandscape(isLandscapeMode);
        };

        // Initial check
        checkOrientation();

        // Listen for window resize
        window.addEventListener('resize', checkOrientation);

        return () => {
            window.removeEventListener('resize', checkOrientation);
        };
    }, []);

    return isLandscape;
};

export default useOrientation;